import { useEffect, useState } from 'react'
import { useRenderHistoryStore } from '@/stores/renderHistory.store'

/** Ready when persist rehydrated OR store already has render rows (SPA navigation). */
export function useRenderHistoryHydrated(): boolean {
  const hasData = useRenderHistoryStore((s) => s.entries.length > 0 || s.active.length > 0)
  const [hydrated, setHydrated] = useState(() => useRenderHistoryStore.persist.hasHydrated())

  useEffect(() => {
    const mark = () => setHydrated(useRenderHistoryStore.persist.hasHydrated())
    mark()
    return useRenderHistoryStore.persist.onFinishHydration(mark)
  }, [])

  return hydrated || hasData
}
